export default __webpack_public_path__ + "static/media/web.7d6ce9f6.png";